import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Form/form';
import { css } from '@patternfly/react-styles';
export var ActionGroup = function ActionGroup(_a) {
  var _a$children = _a.children,
      children = _a$children === void 0 ? null : _a$children,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      props = __rest(_a, ["children", "className"]);

  var customClassName = css(styles.formGroup, styles.modifiers.action, className);
  var formActionsComponent = React.createElement("div", {
    className: css(styles.formActions)
  }, children);
  return React.createElement("div", Object.assign({}, props, {
    className: customClassName
  }), formActionsComponent);
};